import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { LangChangeEvent, TranslateService } from '@ngx-translate/core'
import { PrivacyPolicy } from '../../mocks/privacy-policy.mock'

@Component({
  selector: 'app-privacy-policy',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './privacy-policy.component.html'
})
export class PrivacyPolicyComponent implements OnInit {
  lang: string = this.translate.getCurrentLang()
  privacyPolicy: { heading: string; content: string[] }[]

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.privacyPolicy = PrivacyPolicy[this.translate.getCurrentLang()]

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.lang = event.lang
      this.privacyPolicy = PrivacyPolicy[event.lang]
    })
  }
}
